import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  // Функция для группировки уведомлений по дате
  groupNotificationsByDate() {
    const { restaurant } = this.props
    
    if (!restaurant?.notifications || !Array.isArray(restaurant.notifications)) {
      return {}
    }

    return restaurant.notifications.reduce((groups, notification) => {
      const date = notification.date
      if (!groups[date]) {
        groups[date] = []
      }
      groups[date].push(notification)
      return groups
    }, {})
  }

  // Функция для обработки клика на тег
  handleTagClick(productId, e) {
    e.preventDefault()
    const { openProductWin } = this.props
    
    if (openProductWin && productId) {
      openProductWin(productId)
    }
  }

  // Функция для преобразования HTML строки в React элементы
  renderNotificationText(text) {
    // Простая замена тегов - для более сложного HTML лучше использовать библиотеку типа html-react-parser
    const htmlString = text
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '')
      .replace(/<br\s*\/?>/g, '<br />')
    
    // Разделяем по тегам br и рендерим как отдельные элементы
    const parts = htmlString.split(/(<br \/>|<br>)/)
    
    return parts.map((part, index) => {
      if (part === '<br />' || part === '<br>') {
        return <br key={index} />
      }
      
      // Заменяем теги strong на b
      const processedPart = part.replace(/<strong>(.*?)<\/strong>/g, '<b>$1</b>')
      
      // Опасно использовать dangerouslySetInnerHTML, но для простого примера
      return (
        <span 
          key={index} 
          dangerouslySetInnerHTML={{ __html: processedPart }}
        />
      )
    })
  }

  componentDidMount() {
    const { cookies, restaurant } = this.props

    cookies.set('notifications_md5', restaurant?.notifications_md5, { 
      path: '/',
      maxAge: 365 * 24 * 60 * 60 // 1 год
    })
  }

  render() {
    const { data, user, assets_path } = this.props
    
    // Получаем сгруппированные уведомления
    const groupedNotifications = this.groupNotificationsByDate()

    return (
      <div
        className='bg-cover bg-center bg-no-repeat min-h-svh'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container tracking-tight'>
          <SimpleHeader
            title={data?.pagetitle}
            user={user}
            lk_link={data?.lk_link}
          />
          <div className='mt-[12px] pb-[150px]'>
            {Object.keys(groupedNotifications).length === 0 ? (
              <div className="text-center text-[#00000099] text-[18px] font-medium py-[40px]">
                Нет уведомлений
              </div>
            ) : (
              Object.entries(groupedNotifications).map(([date, notifications]) => (
                <div key={date}>
                  <div className='text-center text-[#00000099] text-[18px] font-medium mb-[15px]'>
                    {date}
                  </div>
                  
                  {notifications.map((notification, index) => (
                    <div 
                      key={`${date}-${index}`}
                      className='p-[15px] rounded-[25px] bg-white mb-[15px]'
                    >
                      <div className='text-[14px] font-medium text-black mb-[15px]'>
                        {this.renderNotificationText(notification.text)}
                      </div>
                      
                      {notification.tags && notification.tags.length > 0 && (
                        <div className='text-[#5A91FF] flex flex-wrap items-center justify-start gap-[5px]'>
                          {notification.tags.map((tag, tagIndex) => (
                            <span 
                              key={tagIndex}
                              className='cursor-pointer hover:underline'
                              onClick={(e) => this.handleTagClick(notification.product_id, e)}
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  user: PropTypes.object,
  restaurant: PropTypes.object,
  assets_path: PropTypes.string,
  openProductWin: PropTypes.func,
  cookies: PropTypes.object
}

export default Main